import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  FormGroup,
  FormControlLabel,
  Checkbox,
  Typography,
} from '@mui/material';

RxOptions.propTypes = {
  setOptions: PropTypes.func.isRequired,
};

export function RxOptions(props) {
  const { setOptions, selectedOption } = props;
  const [elements, setElements] = useState({
    L: selectedOption === 'L',
    P: selectedOption === 'P',
    K: selectedOption === 'K',
  });

  useEffect(() => {
    const selected = Object.entries(elements)
      .filter(([, v]) => v)
      .map(([k]) => k);

    setOptions(selected.length ? { elements: selected } : null);
  }, [elements, setOptions]);

  const baseSelectionStyle = {
    marginTop: 1,
    marginBottom: 0.3,
    marginRight: 0,
    marginLeft: 0,
    borderRadius: 1,
    background: '#F8F8F8',
    boxShadow: 1,
  };

  const checkedStyle = {
    boxShadow: '0px 1px 4px 1px #0000003D inset',
    background: '#EAEAEA',
  };

  return (
    <>
      <Typography variant="body1" sx={{ fontSize: 16 }}>
        Select the prescriptions to include
      </Typography>
      <FormGroup sx={{ minWidth: 364 }}>
        {Object.entries(elements).map(([label, value]) =>
          buildCheckBox(label, value),
        )}
      </FormGroup>
    </>
  );

  function buildCheckBox(name, value) {
    return (
      <FormControlLabel
        key={name}
        control={<Checkbox />}
        name={name}
        onChange={handleSelection}
        checked={value}
        onClick={(e) => e.stopPropagation()}
        label={name}
        sx={applyCheckStyle(value)}
      />
    );
  }

  function handleSelection({ target }) {
    setElements((current) => ({ ...current, [target.name]: target.checked }));
  }

  function applyCheckStyle(checked) {
    return checked
      ? { ...baseSelectionStyle, ...checkedStyle }
      : baseSelectionStyle;
  }
}
